export var VideoState;
(function (VideoState) {
    VideoState["WAITING_FOR_PUBLISH"] = "WAITING_FOR_PUBLISH";
    VideoState["NOT_PUBLISHED"] = "NOT_PUBLISHED";
    VideoState["PUBLISHING"] = "PUBLISHING";
    VideoState["PUBLISHED"] = "PUBLISHED";
    VideoState["EXPIRED"] = "EXPIRED";
})(VideoState || (VideoState = {}));
//# sourceMappingURL=video-state.js.map